export default __webpack_public_path__ + "static/media/icon-description.8f2e69eb.svg";